var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"amap-page-container"},[_c('el-amap',{ref:"map",staticClass:"amap-demo",attrs:{"center":_vm.center,"zoom":_vm.zoom,"plugin":_vm.plugin}},[_c('el-amap-marker',{attrs:{"vid":"amapDemo","position":_vm.center}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }